module.exports = __webpack_public_path__ + "img/xp.7bb69e9b.svg";